<template>
  <div class="hello">
    <div class="container">
      <div class="calendarside">
        <div
          class="campweek"
          v-for="(startDay) in weeks"
          :class="{selected: startDay == week}"
          :key="startDay.toString()"
          @click="selectWeek(startDay)"
        >{{monthweek(startDay)}}</div>
      </div>
      <div class="campside">
        <camp-list :week="week"></camp-list>
      </div>
    </div>
    <p></p>
  </div>
</template>

<script>
import CampList from "./CampList.vue";

export default {
  name: "HelloWorld",
  components: {
    CampList
  },
  props: {
    msg: String
  },
  computed: {
    weeks() {
      var weeks = [];
      for (let i = 0; i < 12; i++) {
        console.log("makingweek");
        let thisDate = new Date(this.first);
        thisDate.setDate(this.first.getDate() + i * 7);
        weeks.push(thisDate);
      }
      console.log(weeks);
      return weeks;
    }
  },
  methods: {
    selectWeek(date) {
      this.week = date;
    },
    monthweek(date) {
      // const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
      //   date
      // );
      const mo = new Intl.DateTimeFormat("en", { month: "short" }).format(date);
      const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
      return mo + " " + da;
    }
  },
  data() {
    return {
      selectedWeek: new Date(),
      week: new Date(),
      first: new Date("June 8, 2020")
    };
  }
};
/*eslint no-unused-vars: "warn"*/
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.container {
  text-align: left;
  display: grid;
  grid-template-columns: 30fr 70fr;
  grid-template-rows: auto;
}
.calendarside {
  background-color: rgb(241, 234, 255);

  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 1;
}
.campside {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 1;
}
.campweek {
  height: 3em;
  border-bottom: 1px solid rgb(184, 184, 184);
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.selected {
  background-color: rgb(151, 147, 147);
}
</style>
